export default __webpack_public_path__ + "static/media/uploadDoc.96efd0c0.svg";